import { InjectionKey } from 'vue';
import { createContext, useContext } from '@mts-fe/hooks';

export interface ModalContextProps {
  getModalHight: () => number;
  redoModalHeight: () => void;
}

const key: InjectionKey<ModalContextProps> = Symbol();

export function createModalContext(context: ModalContextProps) {
  return createContext<ModalContextProps>(context, key);
}

export function useModalContext() {
  return useContext<ModalContextProps>(key);
}
